import React from 'react';

import type { Props } from '@/components/SessionAvailabilityPill/types';
import { Tooltip } from '@/ui';

const tooltipContent = (isWithinPersonAvailability: boolean | null, memberFirstName: string) => {
  if (isWithinPersonAvailability === true) return `${memberFirstName} is available at this time`;
  if (isWithinPersonAvailability === false)
    return `${memberFirstName} is not available at this time`;
  return `No availability on file for ${memberFirstName}`;
};

const SessionAvailabilityPill = ({
  children,
  isWithinPersonAvailability,
  memberFirstName
}: Props) => (
  <Tooltip content={tooltipContent(isWithinPersonAvailability, memberFirstName)}>
    {children}
  </Tooltip>
);

export default React.memo(SessionAvailabilityPill);
